import { ALERTAS_PERMISSIONS, BOLETIM_INFORMATIVO_PERMISSIONS, CENTRAL_DOACOES_PERMISSIONS, COMANDO_INCIDENTES_PERMISSIONS, DACA_PERMISSIONS, PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS, PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS, PLANO_DETALHADO_PERMISSIONS, PLANO_TRABALHO_PERMISSIONS, PRESTACAO_CONTAS_PERMISSIONS, RELATORIO_VISTORIA_PERMISSIONS } from 'constants/permissions';

const rules = {
	default: {
		static: [
			ALERTAS_PERMISSIONS.VISUALIZAR,
			ALERTAS_PERMISSIONS.VISUALIZAR_SOE,
			ALERTAS_PERMISSIONS.GERENCIAR,

			DACA_PERMISSIONS.VISUALIZAR,
			DACA_PERMISSIONS.GERENCIAR_ITEM,
			DACA_PERMISSIONS.GERENCIAR_ENTRADA,
			DACA_PERMISSIONS.GERENCIAR_SAIDA,
			DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO,

			CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR,
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ITEM,
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_OFICIO,
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTIDADE,
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTRADA,
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_SAIDA,

			PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR,
			PRESTACAO_CONTAS_PERMISSIONS.REALIZAR,
			PRESTACAO_CONTAS_PERMISSIONS.ANALISAR,
			PRESTACAO_CONTAS_PERMISSIONS.REVISAR,

			PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.VISUALIZAR,
			PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.ANALISAR,
			PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.REALIZAR,
			PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS.REVISAR,

			PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS.VISUALIZAR,
			PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS.ANALISAR,
			PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS.REALIZAR,
			PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS.REVISAR,

			RELATORIO_VISTORIA_PERMISSIONS.VISUALIZAR,
			RELATORIO_VISTORIA_PERMISSIONS.ANALISAR,
			RELATORIO_VISTORIA_PERMISSIONS.REALIZAR,
			RELATORIO_VISTORIA_PERMISSIONS.REVISAR,

			PLANO_DETALHADO_PERMISSIONS.VISUALIZAR,
			PLANO_DETALHADO_PERMISSIONS.ANALISAR,
			PLANO_DETALHADO_PERMISSIONS.REALIZAR,
			PLANO_DETALHADO_PERMISSIONS.REVISAR,

			PLANO_TRABALHO_PERMISSIONS.VISUALIZAR,
			PLANO_TRABALHO_PERMISSIONS.ANALISAR,
			PLANO_TRABALHO_PERMISSIONS.REALIZAR,
			PLANO_TRABALHO_PERMISSIONS.REVISAR,

			BOLETIM_INFORMATIVO_PERMISSIONS.VISUALIZAR,
			BOLETIM_INFORMATIVO_PERMISSIONS.ANALISAR,
			BOLETIM_INFORMATIVO_PERMISSIONS.REALIZAR,
			BOLETIM_INFORMATIVO_PERMISSIONS.REVISAR,

			COMANDO_INCIDENTES_PERMISSIONS.VISUALIZAR,
			COMANDO_INCIDENTES_PERMISSIONS.ANALISAR,
			COMANDO_INCIDENTES_PERMISSIONS.REALIZAR,
			COMANDO_INCIDENTES_PERMISSIONS.REVISAR,
		],
	},
};

export default rules;
